// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import ConfigurationItemViewModel from "./configuration-item";
import BaoDialogViewModel from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-number-box";
import AppTabController from "../services/app-tab-controller";
import TabPage from "../factories/tab-page";

function ProjectViewModel(tabPage) {
    var self = this;
    ConfigurationItemViewModel.call(this, tabPage);
    self.GoToParentConfigurationItem = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Project");
        newTab.UrlData({
            id: self.ParentConfigurationItemId()
        });
        newTab.ObjectId(self.ParentConfigurationItemId());
        AppTabController.AddTab(newTab);
    };
    self.GoToContract = function (item) {
        baoRouter.setHash("#contract/" + self.ContractId());
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.ConfigurationItemTypeId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.Name1())) {
            isComplete = false;
        }
        if (self.ConfigurationItemStatusId() == null) {
            isComplete = false;
        }
        if (self.TeamLeaderId() == null) {
            isComplete = false;
        }
        $.each(self.TabViewModel.Tabs(), function (index, tab) {
            if (tab.PreLoad()) {
                if (!tab.ViewModel().CompleteCheck()) {
                    self.TabViewModel.SelectTab(tab);
                    isComplete = false;
                    return false;
                }
            }
            return null;
        });
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.ResetAccountAssignment = function (row) {
        self.AccountAssignment(null);
    };
    self.GenerateProjectNumber = function () {
        if (self.Initialized() == true && tabPage.IsLoading() == false) {
            if (Bao.Utils.String.IsNullOrEmpty(self.OfferDateJs()) || self.CustomerId() == null) {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgGenerateProjectNumberCustomerEmpty"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.Number("");
                    }
                });
            }
            else {
                self.CallGenerateProjectNumber();
            }
        }
    };
    self.CallGenerateProjectNumber = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItem/GenerateProjectNumber", JSON.stringify({
            model: self.MinimizeEntity()
        }), function (result) {
            self.Number(result);
            tabPage.IsLoading(false);
        });
    };
}
;
Bao.inherit(ProjectViewModel, ConfigurationItemViewModel);
ProjectViewModel.prototype.DeleteMessageKey = "msgDeleteProject";
ProjectViewModel.prototype.RefreshUrl = "ConfigurationItem/GetProject";
ProjectViewModel.prototype.SaveUrl = "ConfigurationItem/SaveProject";
ProjectViewModel.prototype.DeleteUrl = "ConfigurationItem/DeleteProject";
ProjectViewModel.prototype.PermissionForward = "ProjectMoveForwardSearch";
ProjectViewModel.prototype.PermissionBackward = "ProjectMoveBackwardSearch";
ProjectViewModel.prototype.PermissionRefresh = "ProjectRefresh";
ProjectViewModel.prototype.PermissionSave = "ProjectSave";
ProjectViewModel.prototype.PermissionDelete = "ProjectDelete";
ProjectViewModel.prototype.ConfigurationItemTypeKeyCategory = "Project";
ProjectViewModel.prototype.PermissionAuditTrail = "ProjectAudit";
export default ProjectViewModel;